export default "__VITE_ASSET__BNiy0tVc__"